import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DivLeft = styled.div`
  display: flex;

  display: flex;
  margin-top: 3px;

  div:nth-child(2) {
    margin-left: 30px;
  }
`;
